const CategoryKeys = {
  APPROVAL_AUTHORITY: "approvalauthority",
  ECONOMIC_AREA: "economicArea",
  PRODUCT_CODE: "productcode",
  SCOPE: "scope",
  STANDARD: "standard",
  VALID_TO: "validto"
};

export { CategoryKeys };
